import React from 'react';
import PropTypes from 'prop-types';
import { formatDate, getDiffInDays } from '../../../../utils/date-utils';

const RenDateWithDiff = ({ data, accessor }) => {
  const diffInDays = data[accessor] ? getDiffInDays(data[accessor]) : '';

  return (
    <div className="tbl-ren-date-with-diff">
      <span>{data[accessor] ? formatDate(data[accessor]) : '-'}</span>
      {diffInDays && <span className="supporting-text">{diffInDays}</span>}
    </div>
  );
};

RenDateWithDiff.defaultProps = {
  data: {},
};

RenDateWithDiff.propTypes = {
  id: PropTypes.string.isRequired,
  accessor: PropTypes.string.isRequired,
  data: PropTypes.shape(),
};

export default RenDateWithDiff;
